module.exports = __webpack_public_path__ + "img/dubbelzijdig_50x38mm.ad039202.jpg";